import * as go from 'gojs';
import { getImageGyratoryCrusherCG } from 'unitData/Crushers/GyratoryCrusherCG/getImageGyratoryCrusherCG';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import type { GyratoryCrusherNodeData } from 'gojs/types';

const GyratoryCrusherCGTemplate = makeNode(
  getImageBinding('', (data: GyratoryCrusherNodeData) =>
    getImageGyratoryCrusherCG(data.grizzly, data.showCustomModel),
  ),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default GyratoryCrusherCGTemplate;
